import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { Header } from "./components/Header";
import { LaunchBanner } from "./components/LaunchBanner";
import { HeroSection } from "./components/HeroSection";
import { ReasonsSection } from "./components/ReasonsSection";
import { MascotDivider } from "./components/MascotDivider";
import { HowItWorks } from "./components/HowItWorks";
import { SignUpSection } from "./components/SignUpSection";
import { Footer } from "./components/Footer";
import { FloatingWhatsApp } from "./components/FloatingWhatsApp";
import { FloatingSignUp } from "./components/FloatingSignUp";
import AdminPage from "./pages/AdminPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";

const LandingPage = () => {
  return (
    <div className="min-h-screen">
      <LaunchBanner />
      <Header />
      <HeroSection />
      <ReasonsSection />
      <MascotDivider />
      <HowItWorks />
      <SignUpSection />
      <Footer />
      <FloatingWhatsApp />
      <FloatingSignUp />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/payment-success" element={<PaymentSuccessPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
